import styled, {css} from "styled-components";
import { TiArrowSortedUp, TiArrowSortedDown } from 'react-icons/ti'
import {Flex} from "../MarketStyles";

export const Row = styled.div`
  margin: 4px 0;
  border-bottom: 0;
  display: grid;
  grid-template-columns: ${props => props.cs};
  row-gap: 5px;
  color: ${props => props.theme.color};
  padding: ${props => props.padding || '10px'};
  border-radius: 4px;
  font-size: 0.8rem;
  align-items: center;
  transition: all 0.3s;
  width: 100%;
  position: relative;

  ${props => props.action && css`
    background-image: 
            linear-gradient(
                    45deg, 
                    ${({action, theme}) => action === 'active' ? theme.mainGreen : theme.mainRed}10 20%, 
                    ${props => props.theme.table} 60%
            );
  `};
  
  background-color: ${props => props.index % 2 ? props.theme.secondaryBg : props.theme.primaryBg};

  ${props => props.header && css`
    background-color: transparent;
  `};

  ${props => props.hasParty && css`
    background-image:
        linear-gradient(
            45deg,
            #819F8230 0%,
            ${props => props.index % 2 ? props.theme.secondaryBg : props.theme.primaryBg} 25%
        );
  `};
  
  ${props => !props.header && css`
    min-height: 64px;
  `};
  
  ${props => props.currentOrder && css`
    &::after{
      content: ' ';
      position: absolute;
      width: ${props => props.percent && props.percent}%;
      height: 100%;
      
      ${props => props.theme.english && css`
        left: 0;
      `};
      ${props => !props.theme.english && css`
        right: 0;
      `};

      bottom: 0;
      background-color: ${props => props.type === 'buy' ? props.theme.mainGreen : props.theme.mainRed}10;
      /* background-color: ${props => props.theme.mainGreen}15; */
      border-radius: 4px;

      @media screen and (max-width: 1050px) {
        height: ${props => props.percent && props.percent}%;
        width: 100%;
      };
    };
  `};
  
  ${props => !props.noHover && css`
    &:hover{
      ${props => !props.header && css`
      background-color: ${props => props.theme.tInputBg};
      transform: scale(1.02);
      
      @media screen and (max-width: 1050px) {
        transform: scale(1);
      };
    `};
  `};
  };

  @media screen and (max-width: 1050px) {
    padding: 15px;
  };
`


export const Column = styled.div`
  display: flex;
  line-break: auto;
  padding: 0 4px;
  min-width: ${props => props.width && props.width};

  ${props => props.center && css`
    justify-content: center;
    align-items: center;
  `};

  ${props => props.more && css`
    justify-content: flex-end;
    align-items: center;
  `};

  ${props => props.avatar && css`
    align-items: center;
  `};

  ${props => props.operation && css`
    position: absolute;
    top: 22%;
    ${props => props.theme.english && css`
      right: 8px;
    `};
    ${props => !props.theme.english && css`
      left: 8px;
    `};
  `};
`

export const SortUp = styled(TiArrowSortedUp)`
  color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
  margin-bottom: -3px;
`

export const SorDown = styled(TiArrowSortedDown)`
  color: ${props => props.active ? props.theme.mainOrange : props.theme.color};
  margin-top: -3px;
`


export const TableWrapper = styled.div`
  min-width: 1000px;
  padding: 0 5px;
  
  @media screen and (max-width: 1050px) {
    min-width: unset;
  }
`

export const TableBody = styled.div`
  width: 100%;
  display: inline-block;
  height: calc(100% - 200px);
  padding: 10px 15px;
  overflow: auto;
`

export const TradeTypeBadge = styled.div`
  padding: 4px 10px;
  background-color: ${props => props.color || props.theme.tInputBg}80;
  border: 1px solid ${props => props.color || props.theme.tInputBg};
  font-size: 0.9rem;
  border-radius: 8px;
  min-width: 64px;
  text-align: center;
  color: ${props => props.theme.color};
  line-break: auto;
  word-wrap: break-word;

  @media screen and (max-width: 1050px) {
    padding: 2px 10px;
    font-size: 0.8rem;
  };
`


export const HistoryResponsiveRow = styled(Flex)`
  justify-content: space-between;
  margin: 4px 0;
  width: 100%;
`
